__webpack_require__.p = "https://automation.devarsh.ir/";